import React, { useState, useEffect } from "react";
import { Man1, TestimonialsJustineTiu, TestimonialJiakeLiu, TestimonialsTaylorBorenstein } from "../../assets/assets";

const testimonials = [
  {
    name: "Saleh Anas",
    role: "CEO",
    company: "Yuicery",
    photo: Man1,
    quote: (
      <>
        Our former refund process caused unexpected customer churn. But ever since we switched to Pabloo, we've noticed a significant drop in checkout churn. Plus, Pabloo's platform has given us{" "}
        <span className="text-green-700 font-semibold">the ability to use store credit strategically</span>.
      </>
    ),
  },
  {
    name: "Taylor Borenstein",
    role: "Co-Founder",
    company: "Stakt",
    photo: TestimonialsTaylorBorenstein,
    quote: (
      <>
        We were able to adopt and work with Pabloo in the same day, and were delighted with getting our first savings alongside our onboarding process.{" "}
        <span className="text-green-700 font-semibold">I highly recommend that any company looking for a Store Credit partner contact Pabloo.</span>{" "}
        They'll take care of everything while you concentrate on growing your business.
      </>
    ),
  },
  {
    name: "Justine Tiu",
    role: "Co-Founder",
    company: "The Woobles",
    photo: TestimonialsJustineTiu,
    quote: (
      <>
        Pabloo proactively manages our store credit reporting, making our lives so much easier. Compared to similar products we've used in the past,{" "}
        <span className="text-green-700 font-semibold">the customer experience with Pabloo has been nothing short of delightful</span>.
        {" "}We no longer have to worry about getting the best results — it's all taken care of on auto-pilot!
      </>
    ),
  },
  {
    name: "Jiake Liu",
    role: "CEO",
    company: "Outer",
    photo: TestimonialJiakeLiu,
    quote: (
      <>
        Pabloo has become an integral part of our team. They're not just a platform; they're a reliable partner.{" "}
        <span className="text-green-700 font-semibold">Their innovative solutions have transformed our business, providing not just store credit but a collaborative efficiency we hadn't experienced before.</span>{" "}
        My overall experience with the Pabloo team has been brilliant.
      </>
    ),
  },
];

const TOTAL = testimonials.length;

export default function TestimonialComponent() {
  const [current, setCurrent]       = useState(0);
  const [resetKey, setResetKey]     = useState(0);
  const [progressKey, setProgressKey] = useState(0);

  const handleSelect = (i) => {
    setCurrent(i);
    setResetKey((k) => k + 1);
    setProgressKey((k) => k + 1);
  };

  const prev = () => handleSelect((current - 1 + TOTAL) % TOTAL);
  const next = () => handleSelect((current + 1) % TOTAL);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % TOTAL);
      setProgressKey((k) => k + 1);
    }, 5000);
    return () => clearInterval(timer);
  }, [resetKey]);

  const t = testimonials[current];

  return (
    <section className="w-full bg-white py-20 px-4">
      <div className="max-w-4xl mx-auto">

        {/* Quote mark */}
        <div className="text-green-200 mb-6 select-none" style={{ fontSize: "80px", lineHeight: 1, fontFamily: "Georgia, serif" }}>
          &ldquo;
        </div>

        {/* Quote */}
        <p className="text-2xl md:text-3xl text-gray-800 leading-snug font-medium mb-10" style={{ minHeight: "140px" }}>
          {t.quote}
        </p>

        {/* Author row */}
        <div className="flex items-center justify-between flex-wrap gap-6">
          <div className="flex items-center gap-4">
            <img
              src={t.photo}
              alt={t.name}
              className="w-14 h-14 rounded-full object-cover border-2 border-gray-100 shadow-sm"
            />
            <div>
              <p className="text-sm font-bold text-gray-900">{t.name}</p>
              <p className="text-sm text-gray-500">{t.role} · <span className="text-green-700 font-semibold">{t.company}</span></p>
            </div>
          </div>

          {/* Arrows + progress indicators */}
          <div className="flex items-center gap-4">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-gray-400 hover:text-gray-800 transition-colors"
              aria-label="Previous"
            >
              <svg width={10} height={16} viewBox="0 0 10 16" fill="none">
                <path d="M8.75 1.25L2 8l6.75 6.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            {/* Progress bar indicators */}
            <div className="flex items-center gap-1.5">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => handleSelect(i)}
                  aria-label={`Go to testimonial ${i + 1}`}
                  style={{
                    width:        i === current ? "48px" : "8px",
                    height:       "4px",
                    borderRadius: "99px",
                    border:       "none",
                    padding:      0,
                    cursor:       "pointer",
                    background:   i === current ? "transparent" : "#e5e7eb",
                    overflow:     "hidden",
                    transition:   "width 0.3s ease",
                    position:     "relative",
                  }}
                >
                  {i === current && (
                    <div
                      key={progressKey}
                      className="tab-progress-fill-h"
                      style={{ height: "100%", background: "#15803d", borderRadius: "99px" }}
                    />
                  )}
                </button>
              ))}
            </div>

            <button
              onClick={next}
              className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-gray-400 hover:text-gray-800 transition-colors"
              aria-label="Next"
            >
              <svg width={10} height={16} viewBox="0 0 10 16" fill="none">
                <path d="M1.25 1.25L8 8l-6.75 6.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
